import { useRef } from "react";
import fetchData from "../../shared/fetchData";
import GridModel from "../UI/GridModel/GridModel";
import Button from "../UI/Button/Button";
import Modal from "../UI/Modal/Modal";

const KioskUnit = (props) => {
    const childRef = useRef();

    const afterCloseModal = (event) => {
    }

    const cols = props.data != null ? [
        { label: "حساب", value: props.data.unitDescription },
        { label: "لاکر", value: props.data.kioskDescription },
        { label: "تعداد ", value: props.data.maxCount },
        { label: "وضعیت ", value: !!props.data.isActive && props.data.isActive == '1' ? 'فعال است' : 'فعال نیست' },
        ,
    ] :
        [];
    const KioskUnitChangeStateSubmited = (event) => {
        var raw = JSON.stringify({
            "kioskUnit": {
                "id": props.data.id
            },
            "pl": 1000,
            "pn": 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/kioskunits/changeKioskUnitState'
        fetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    childRef.current.closeModal();
                    props.reload();
                }
            })
            .catch(error => console.log())
    }

    const modalContent = <div>
        <div className="row justify-content-center">
            آيا از تغيير وضعيت مطمئن هستيد؟
        </div>
        <div className="row justify-content-center mt-5">
            <div className="col-6">
                <Button btnType="Success" clicked={KioskUnitChangeStateSubmited} >بله</Button>
            </div>
            <div className="col-6">
                <Button btnType="General" clicked={() => childRef.current.closeModal()} >خير</Button>
            </div>
        </div>
    </div>
    const kioskUnitChangeState = () => {
        childRef.current.openModal();
    }
    return (
        <div className="row justify-content-center mt-1">


            <GridModel hasView={false} edit={(event) => props.edit(event, props.data.id)} hasEdit={true} model={cols} />

            <div className="row justify-content-center w-100">
                <div className="row w-75" dir="ltr">
                    <div className="col-2 text-left grid-small-btn">
                        <Button btnType="Grid" clicked={kioskUnitChangeState} >تغییر وضعیت</Button>
                    </div>
                </div>
            </div>
            <Modal
                content={modalContent}
                ref={childRef}
                closePermission="true"
                closeModal=
                {(event) => afterCloseModal(event)}

            />
        </div>
    )
}

export default KioskUnit;